module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mRNnu/tc-custom/9781614239796.jpg?1702530286759",
      "alt": "This image is the cover for the book Legends, Lore and Secrets of New England, American Legends"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Legends, Lore and Secrets of New England, American Legends\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("New England's history is marked with witch executions, curses and an untold number of cemeteries hiding mysteries beneath their stones. In this sometimes harsh landscape, the truth is often stranger than fiction. Examine the footprints burned into the ledge of Devil's Foot Rock in Rhode Island. Spend a night at the Kennebunk Inn in Maine, where the mischievous specter of Silas Perkins still resides. Traverse an old dirt road near Sterling, Connecticut, where the Darn Man's frozen body was uncovered in 1863. Authors Thomas D'Agostino and Arlene Nicholson uncover the history behind the region's best-kept secrets and lore. As you flip through these pages of New England's legends, tread lightly--you just might find a story that will follow you home.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thomas D'Agostino, Arlene Nicholson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tom D'Agostino is a renowned author, paranormal researcher and investigator. He has over 30 years experience and has done more than a thousand investigations. D'Agostino has appeared on numerous radio programs, television shows and documentaries. Arlene Nicholson has a degree in photography and has authored numerous books on ghosts, haunts and legends of New England. She has researched and investigated paranormal activity for over 30 years. Nicholson has appeared on several television shows and documentaries about the paranormal.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0